var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "modal",
    {
      staticClass: "modal",
      attrs: {
        printButton: "",
        downloadButton: "",
        close: _vm.closeModal,
        title: _vm.title,
        printStyle: _vm.printStyle,
      },
    },
    [
      _c(
        "h3",
        {
          staticClass: "modal__header",
          attrs: { slot: "modalHeader" },
          slot: "modalHeader",
        },
        [
          _c("i", { staticClass: "uk-icon-hand-o-up" }),
          _vm._v(" Исполнительные производства " + _vm._s(_vm.companyName)),
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__content",
          attrs: { slot: "modalBody" },
          slot: "modalBody",
        },
        [
          !_vm.isLoading && _vm.list && _vm.list.length
            ? [
                _c("h4", { staticClass: "cases-title" }, [
                  _vm._v(_vm._s(_vm.execTitle) + " "),
                  _c("i", { staticClass: "uk-icon-rub" }),
                ]),
                _vm._v(" "),
                _c(
                  "ul",
                  _vm._l(_vm.list, function (c, i) {
                    return _c("executory-item", { key: i, attrs: { exec: c } })
                  }),
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isLoading ? _c("loading") : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "modal__footer",
          attrs: { slot: "modalFooter" },
          slot: "modalFooter",
        },
        [
          _vm.paginationObj && _vm.paginationObj.rows_count > 100
            ? _c("old-pagination", {
                attrs: {
                  paginationObj: _vm.paginationObj,
                  getNewContent: _vm.nextPage,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }